import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { Watermark } from "./components/Watermark";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Manifesto } from "./components/Manifesto";
import { Hours } from "./components/Hours";
import { MenuSection } from "./components/MenuSection";
import { Reviews } from "./components/Reviews";
import { Footer } from "./components/Footer";
import { LegalOverlay } from "./components/LegalOverlay";

function App() {
  const [legal, setLegal] = useState(null);
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (legal) lenisRef.current?.stop();
    else lenisRef.current?.start();
  }, [legal]);

  return (
    <div className="paper-noise relative min-h-screen bg-[#F9F8F6]">
      <Watermark />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Hours />
        <MenuSection />
        <Reviews />
      </main>
      <Footer onLegal={setLegal} />
      {legal && <LegalOverlay page={legal} onClose={() => setLegal(null)} />}
    </div>
  );
}

export default App;
